import React from "react";
import "./appointment-scheduling.scss";
import Header from "../../components/Header/Header";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Footer from "../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import useAlertUtils from "../../utils/common.utils";
import { fetchData } from "../../services/apiService";

function AppointmentIndexPage() {
  const token = localStorage.getItem("token");
  const [bookingsData, setBookingsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { alertError } = useAlertUtils();

  const getUserBookings = async (decoded) => {
    try {
      const data = await fetchData(
        `api/booking/get-user-bookings/${decoded.userId}`
      );
      const sortedData = data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setBookingsData(sortedData);
      setLoading(false);
    } catch (error) {
      alertError("Error Fetching Booking Data");
    }
  };

  useEffect(() => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join("")
    );

    const decoded = JSON.parse(jsonPayload);
    getUserBookings(decoded);
  }, []);

  const navigate = useNavigate();

  const handleNavigate = (token) => {
    if (token) {
      localStorage.setItem("productURL", "/app/appointment-scheduling");
      navigate("/app/medical-history");
    } else {
      localStorage.setItem("productURL", "/app/appointment-scheduling");
      navigate("/register");
    }
  };
  return (
    <div className="appointment-page">
      {token ? <Header></Header> : <PreLoginHeader></PreLoginHeader>}
      {loading ? (
        <>
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        </>
      ) : (
        <>
          {bookingsData && bookingsData.length !== 0 ? (
            <div className="main_content">
              <div className="container">
                <div className="main_block">
                  <div className="top_bar">
                    <div className="left_part">
                      <div className="main_title">Scheduled Appointments</div>
                    </div>
                    <div className="right_part">
                      <div className="right_part_inner">
                        <button
                          onClick={() => handleNavigate(token)}
                          className="btn btn-primary add_kit"
                        >
                          Schedule Appointments
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="table_wrapper dashboard">
                    <div className="table_inner">
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              {/* <TableCell align="right">First Name</TableCell>
                          <TableCell align="right">Last Name</TableCell> */}
                              <TableCell align="right">Email</TableCell>
                              <TableCell align="right">Meeting Date</TableCell>
                              <TableCell align="right">Meeting Time</TableCell>
                              <TableCell align="right">Status</TableCell>
                              <TableCell align="right">Meeting Link</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {bookingsData &&
                              bookingsData.map((row) => (
                                <TableRow
                                  key={row?.id}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  {/* <TableCell align="right">
                                <span className="mob_head">First Name</span>
                                {row?.user?.firstName}
                              </TableCell>
                              <TableCell align="right">
                                <span className="mob_head">Last Name</span>
                                {row?.user?.lastName}
                              </TableCell> */}

                                  <TableCell align="right">
                                    <span className="mob_head">Email</span>
                                    {row?.attendeeEmail}
                                  </TableCell>

                                  <TableCell align="right">
                                    <span className="mob_head">
                                      Meeting Date
                                    </span>
                                    {new Date(
                                      row?.meetingStartSlot
                                    ).toLocaleDateString("en-US", {
                                      weekday: "long",
                                      month: "long",
                                      day: "numeric",
                                    })}
                                  </TableCell>

                                  <TableCell align="right">
                                    <span className="mob_head">
                                      Meeting Time
                                    </span>
                                    {new Date(
                                      row?.meetingStartSlot
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </TableCell>

                                  <TableCell align="right">
                                    <span className="mob_head">Status</span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        padding: "5px 10px",
                                        borderRadius: "5px",
                                        backgroundColor:
                                          row?.Status === "Pending"
                                            ? "#fc7f03"
                                            : row?.Status === "Done"
                                            ? "green"
                                            : row?.Status === "Expired"
                                            ? "red"
                                            : null,
                                        color: "white",
                                      }}
                                    >
                                      {row?.Status}
                                    </span>
                                  </TableCell>

                                  <TableCell align="right">
                                    <span className="mob_head">Action</span>
                                    <button
                                      disabled={row.Status !== "Pending"}
                                      onClick={() => {
                                        if (row.Status === "Pending") {
                                          window.open(
                                            row?.meetingLink,
                                            "_blank"
                                          );
                                        }
                                      }}
                                      style={{
                                        cursor:
                                          row.Status === "Pending"
                                            ? "pointer"
                                            : "not-allowed",
                                        opacity:
                                          row.Status === "Pending" ? 1 : 0.6,
                                        padding: "8px 16px",
                                        border: "none",
                                        backgroundColor: "#007bff",
                                        color: "#fff",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      Meeting Link
                                    </button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="modern-hero">
                <div className="hero-content">
                  <div className="text-content">
                    <div className="tagline">Advanced Weight Solution</div>
                    <h1>
                      <span className="gradient-text">GLP-1</span> Therapy
                      <br />
                      Redefined
                    </h1>
                    <p className="subhead">
                      Clinically-formulated medications tailored to your
                      metabolic needs
                    </p>

                    <div className="pricing-highlight">
                      <div className="price">
                        <span className="old-price">$247</span>
                        <span className="new-price">$197</span>
                      </div>
                      <div className="price-label">First month treatment</div>
                    </div>

                    <button
                      onClick={() => handleNavigate(token)}
                      className="modern-cta"
                    >
                      Begin Your Transformation
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M5 12H19M19 12L12 5M19 12L12 19"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>

                  <div className="visual-content">
                    <div className="image-wrapper">
                      <img
                        src="https://cdn.prod.website-files.com/632a33dda7f9eab7436897cc/66284ef321317aa1e648fbc2_anti%20(1).webp"
                        alt="Happy patient achieving health goals"
                      />
                    </div>
                  </div>
                </div>

                <div className="benefits-bar">
                  <div className="benefit">
                    <div className="icon">🏆</div>
                    <div className="text">FDA-Approved</div>
                  </div>
                  <div className="benefit">
                    <div className="icon">👩‍⚕️</div>
                    <div className="text">Medical Supervision</div>
                  </div>
                  <div className="benefit">
                    <div className="icon">📦</div>
                    <div className="text">Discreet Shipping</div>
                  </div>
                  <div className="benefit">
                    <div className="icon">💳</div>
                    <div className="text">No Insurance Needed</div>
                  </div>
                </div>
              </div>

              <div className="process-section">
                <h2>Simple 3-Step Process</h2>
                <div className="steps">
                  <div className="step">
                    <div className="step-number">1</div>
                    <h3>Online Assessment</h3>
                    <p>Complete our brief health questionnaire</p>
                  </div>
                  <div className="step">
                    <div className="step-number">2</div>
                    <h3>Provider Review</h3>
                    <p>Our medical team evaluates your case</p>
                  </div>
                  <div className="step">
                    <div className="step-number">3</div>
                    <h3>Medication Delivery</h3>
                    <p>Receive treatment at your doorstep</p>
                  </div>
                </div>
              </div>

              <div className="included-section">
                <h2>Your Program Includes</h2>
                <div className="inclusions">
                  <div className="inclusion-card">
                    <div className="icon">💊</div>
                    <h3>Monthly Medication</h3>
                    <p>Precise dosing for optimal results</p>
                  </div>
                  <div className="inclusion-card">
                    <div className="icon">📱</div>
                    <h3>Digital Tools</h3>
                    <p>Progress tracking and support</p>
                  </div>
                  <div className="inclusion-card">
                    <div className="icon">👨‍⚕️</div>
                    <h3>Provider Access</h3>
                    <p>Ongoing medical supervision</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
      <Footer></Footer>
    </div>
  );
}

export default AppointmentIndexPage;
